import React, { useEffect, useState } from "react";
import LoanPlan from "./lonaPlan";
import { useQuery } from "react-query";
import { GetAllLoanTemplates } from "../../services/loanTemplate.service";
import { GetAllLoanTemplatesResponse } from "../../models/loanTemplate.model";
import LoanPlanSkeleton from "./LoanPlanSkeleton";
import { LOANPLANTYPEID } from "../../config/cacheKey";

export default function LoanPlans() {
  const [loanPlans, setLoanPlans] = useState<GetAllLoanTemplatesResponse[]>([]);
  const { data, isLoading } = useQuery(
    "loanPlans",
    () => {
      return GetAllLoanTemplates();
    },
    {
      onSuccess: (data) => {
        setLoanPlans(data);
      },
    }
  );
  useEffect(() => {
    localStorage.removeItem(LOANPLANTYPEID);
  }, []);
  if (isLoading) {
    return (
      <div>
        {[...Array(3)].map((_, index) => (
          <LoanPlanSkeleton key={index} />
        ))}
      </div>
    );
  }
  return (
    <div>
      {loanPlans.map((item, index) => (
        <LoanPlan key={index} {...item} />
      ))}
    </div>
  );
}
